"use client";
import React, { useEffect } from "react";
import { Row } from "reactstrap";
import useAppDispatch from "@/app/hooks/useAppDispatch";
import { hideToast } from "@/store/contactPremiumSlice";
import { useSelector } from "react-redux";
import { RootState } from "@/store";
import { useContactForm } from "./hooks/useContactForm";
import InformationSection from "./components/InformationSection";
import ContactForm from "./components/ContactForm";

const TabContactPremium: React.FC = () => {
  const dispatch = useAppDispatch();

  // Get user from Redux
  const { user } = useSelector((state: RootState) => state.user);

  // Get form handling logic from our custom hook
  const {
    formData,
    errors,
    touched,
    toastLoading,
    isFormValid,
    handleChange,
    handleBlur,
    handleSubmit,
    handleClearAll,
  } = useContactForm();

  // Get toast state from Redux
  const { toast } = useSelector((state: RootState) => state.contactPremium);

  // Auto-hide toast after 3 seconds
  useEffect(() => {
    if (toast.visible) {
      const timer = setTimeout(() => {
        dispatch(hideToast());
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [toast.visible, dispatch]);

  return (
    <div className="mt-4 mb-4">
      <h4 className="font-medium">We're here to help</h4>
      <hr className="border-t-2 !border-gray-300 my-4 w-full"></hr>
      <Row>
        {/* Information Section */}
        <InformationSection user={user} />
        {!user && (
          <ContactForm
            formData={formData}
            errors={errors}
            touched={touched}
            toast={toast}
            toastLoading={toastLoading}
            isFormValid={isFormValid}
            handleChange={handleChange}
            handleBlur={handleBlur}
            handleSubmit={handleSubmit}
            handleClearAll={handleClearAll}
          />
        )}
      </Row>
    </div>
  );
};

export default React.memo(TabContactPremium);
